module.exports = __webpack_public_path__ + "img/Facebook.026ded88.png";